import { getApiBaseUrl } from './apiClient';

// Gerar UUID v4 para sessionId
export function generateSessionId() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

// Obter ou criar sessionId
export function getSessionId() {
  let sessionId = localStorage.getItem('tracking_session_id');
  
  if (!sessionId) {
    sessionId = generateSessionId();
    localStorage.setItem('tracking_session_id', sessionId);
  }
  
  return sessionId;
}

// Detectar informações do dispositivo
function getDeviceInfo() {
  return {
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
  };
}


// Salvar pesquisa do Instagram
export async function saveInstagramSearch(username, profileData = {}, avatarUrl = null) {
  try {
    const sessionId = getSessionId();
    const apiBase = getApiBaseUrl();
    
    const response = await fetch(`${apiBase}/api/tracking/instagram-search`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username,
        profileData,
        avatarUrl,
        sessionId
      })
    });

    if (!response.ok) {
      console.warn('[Tracking] Erro ao salvar pesquisa do Instagram:', response.status);
      return null;
    }

    const data = await response.json();
    console.log('[Tracking] Pesquisa do Instagram salva com sucesso:', data);
    return data;
  } catch (error) {
    console.error('[Tracking] Erro ao salvar pesquisa do Instagram:', error);
    return null;
  }
}

// Rastrear UTM e informações de entrada
export async function trackUtm() {
  try {
    const sessionId = getSessionId();
    
    // Verificar se já foi rastreado nesta sessão
    const tracked = localStorage.getItem('utm_tracked');
    if (tracked === sessionId) {
      console.log('[Tracking] UTM já rastreado para esta sessão');
      return null;
    }

    // Capturar parâmetros UTM da URL
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    const utmTerm = urlParams.get('utm_term');
    const utmContent = urlParams.get('utm_content');

    // Se não há UTMs, ainda assim salvar o referrer e landing page
    const hasUtm = utmSource || utmMedium || utmCampaign || utmTerm || utmContent;
    
    const trackingData = {
      sessionId,
      utmSource,
      utmMedium,
      utmCampaign,
      utmTerm,
      utmContent,
      referrer: document.referrer || null,
      landingPage: window.location.href,
      deviceInfo: getDeviceInfo()
    };

    const apiBase = getApiBaseUrl();
    
    const response = await fetch(`${apiBase}/api/tracking/utm`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(trackingData)
    });

    if (!response.ok) {
      console.warn('[Tracking] Erro ao salvar UTM:', response.status);
      return null;
    }

    const contentType = response.headers.get('content-type') || '';
    const text = await response.text();
    if (!contentType.includes('application/json') || text.trim().startsWith('<')) {
      console.warn('[Tracking] Resposta UTM não é JSON (ex.: 404 em produção). Configure REACT_APP_API_URL.');
      return null;
    }
    const data = JSON.parse(text);
    console.log('[Tracking] UTM salvo com sucesso:', data);

    // Marcar como rastreado para esta sessão
    localStorage.setItem('utm_tracked', sessionId);

    return data;
  } catch (error) {
    console.error('[Tracking] Erro ao rastrear UTM:', error);
    return null;
  }
}
